export default {
    path: '/slider',
    name: 'AppSlider',
    component: () => import('@/views/fast_editor/slider.vue'),
    meta: {
        title: 'Главная',
        forVisitors: true
    }
}